var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.179 16.8294C14.9949 17.8275 13.459 18.43 11.7807 18.43C8.03582 18.43 5 15.4303 5 11.73C5 8.02966 8.03582 5.02997 11.7807 5.02997C13.459 5.02997 14.9949 5.63247 16.179 6.63051C17.363 5.63247 18.8989 5.02997 20.5773 5.02997C24.3221 5.02997 27.358 8.02966 27.358 11.73C27.358 15.4303 24.3221 18.43 20.5773 18.43C18.8989 18.43 17.363 17.8275 16.179 16.8294Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1797 16.8294C17.6376 15.6005 18.5621 13.7719 18.5621 11.73C18.5621 9.68801 17.6376 7.85941 16.1797 6.63051C17.3637 5.63247 18.8996 5.02997 20.578 5.02997C24.3228 5.02997 27.3587 8.02966 27.3587 11.73C27.3587 15.4303 24.3228 18.43 20.578 18.43C18.8996 18.43 17.3637 17.8275 16.1797 16.8294Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1793 16.8294C17.6372 15.6005 18.5616 13.7719 18.5616 11.73C18.5616 9.68804 17.6372 7.85945 16.1793 6.63054C14.7213 7.85945 13.7969 9.68804 13.7969 11.73C13.7969 13.7719 14.7213 15.6005 16.1793 16.8294Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.4df2b7bdc391db4eaff2012e5d2a329c.svg";
export { ForwardRef as ReactComponent };